import { TableColumn } from "react-data-table-component";
import { Link } from "react-router-dom";
import { H6, Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import {
  LatestSalesTableType,
  RecentSalesImageType,
  RecentSalesTableType,
  TopSellingColumnType,
} from "../../../Type/Dashboard/EcommerceType";
import { Href } from "../../../utils/Constant";

export const ecommerceRevenueData = [
  {
    title: "Ecommerce Revenue",
    amount: "$256,980",
    icon: "arrow-down",
    color: "secondary",
    percentage: "- 12.32%",
  },
  {
    title: "New Customers",
    amount: "654",
    icon: "arrow-up",
    color: "success",
    percentage: "- 12.32%",
  },
  {
    title: "Repeat Purchase Rate",
    amount: "23.64%",
    icon: "arrow-down",
    color: "secondary",
    percentage: "- 12.32%",
  },
  {
    title: "Average Order Value",
    amount: "12.56%",
    icon: "arrow-up",
    color: "success",
    percentage: "- 12.32%",
  },
];

export const salesCircleData = [
  {
    color: "primary",
    status: "Pending",
    amount: "$4,875",
  },
  {
    color: "secondary",
    status: "Complete",
    amount: "$1,450",
  },
];

export const conversionRateTableBody = [
  {
    year: "2021",
    customers: "51,696",
    trend: "10%",
    revenue: "$123K",
  },
  {
    year: "2022",
    customers: "13,845",
    trend: "23%",
    revenue: "$23K",
  },
  {
    year: "2023",
    customers: "32,456",
    trend: "31%",
    revenue: "$346K",
  },
];

export const regularCustomersData = [
  {
    title: "Regular Customers",
    amount: "34,837",
    icon: "arrow-up",
    color: "success",
    percentage: "- 12.32%",
  },
  {
    title: "New Customers",
    amount: "+23,684",
    icon: "arrow-down",
    color: "secondary",
    percentage: "- 12.22%",
  },
];

export const activeUsersCountriesData = [
  {
    image: "1.png",
    name: "United States",
    progressValue: "60",
  },
  {
    image: "2.png",
    name: "United kingdom",
    progressValue: "50",
  },
  {
    image: "3.png",
    name: "Sweden",
    progressValue: "30",
  },
  {
    image: "4.png",
    name: "India",
    progressValue: "80",
  },
];
 

export const topSellingTableData: TopSellingColumnType[] = [
 {
    productName: 'Mi watch revolve',
    productImage: '../assets/images/dashboard-2/product/1.png',
    price: '$726',
    clientName: 'John Keter',
    date: 'Jun, 4',
    sold: '400 pcs',
    earning: '$78.700',
  },
  {
    productName: 'Tree stylish pot',
    productImage: '../assets/images/dashboard-2/product/2.png',
    price: '$698',
    clientName: 'Harry Venter',
    date: 'Aug, 8',
    sold: '266 pcs',
    earning: '$64.8450',
  },
  {
    productName: 'Wood Chair Dark',
    productImage: '../assets/images/dashboard-2/product/3.png',
    price: '$158',
    clientName: 'Loadin Deo',
    date: 'May, 8',
    sold: '199 pcs',
    earning: '$39.548',
  },
  {
    productName: 'Sneakers for men',
    productImage: '../assets/images/dashboard-2/product/4.png',
    price: '$942',
    clientName: 'Fenter Jessy',
    date: 'Nov, 4',
    sold: '495 pcs',
    earning: '$95.594',
  },
];

export const latestSalesTableData: LatestSalesTableType[] = [
  {
    customer: {
      name: 'Ernest Elliott',
      email: 'ernest@gmail.com',
      image: '../assets/images/dashboard-2/user/1.png'
    },
    product: 'Shoes',
    productId: '#A5647KB',
    address: 'Germany',
    total: '$560.65',
    payment: 'Done',
    status: 'Received'
  },
  {
    customer: {
      name: 'Helen Emmert',
      email: 'helen@gmail.com',
      image: '../assets/images/dashboard-2/user/2.png'
    },
    product: 'Shirt',
    productId: '#NB86H2E',
    address: 'Switzerland',
    total: '$560.65',
    payment: 'Pending',
    status: 'Shipping'
  },
  {
    customer: {
      name: 'Miguel Thomas',
      email: 'miguel@gmail.com',
      image: '../assets/images/dashboard-2/user/3.png'
    },
    product: 'Travel Bag',
    productId: '#UB654GH',
    address: 'Argentina',
    total: '$956.42',
    payment: 'Done',
    status: 'Received'
  },
  {
    customer: {
      name: 'Augustine Ebron',
      email: 'augustin@gmail.com',
      image: '../assets/images/dashboard-2/user/4.png'
    },
    product: 'Cap',
    productId: '#BAS4567',
    address: 'Canada',
    total: '$645.23',
    payment: 'Pending',
    status: 'Shipping'
  }
];

 
 
 
 
export const recentSalesTableData = [
  {
    productName: 'MacBook Pro',
    productImage: '../assets/images/dashboard-2/product/5.png',
    orderedBy: 'Kevin Marshal',
    quantity: 628,
    price: '$652'
  },
  {
    productName: 'Apple watch',
    productImage: '../assets/images/dashboard-2/product/6.png',
    orderedBy: 'Justion Carter',
    quantity: 95,
    price: '$954'
  },
  {
    productName: 'Apple headphone',
    productImage: '../assets/images/dashboard-2/product/7.png',
    orderedBy: 'Angelina Stathom',
    quantity: 15,
    price: '$629'
  },
  {
    productName: 'Sneakers for men',
    productImage: '../assets/images/dashboard-2/product/4.png',
    orderedBy: 'John Wick',
    quantity: 95,
    price: '$954'
  },
  {
    productName: 'I phone 14 pro',
    productImage: '../assets/images/dashboard-2/product/8.png',
    orderedBy: 'Aron Marhal',
    quantity: 21,
    price: '$525'
  }
];

const RecentSalesImage: React.FC<RecentSalesImageType> = ({
  image,
  product,
}) => {
  return (
    <div className="d-flex gap-2">
      <Image src={dynamicImage(`dashboard-2/product/${image}`)} alt="user" />
      <Link to={Href}>
        <H6 className="f-w-600">{product}</H6>
      </Link>
    </div>
  );
};

export const recentSalesTableColumn: TableColumn<RecentSalesTableType>[] = [
  {
    name: "Product Name",
    cell: (row) => <RecentSalesImage image={row.image} product={row.product} />,
    sortable: true,
  },
  {
    name: "Ordered By",
    selector: (row: RecentSalesTableType) => row["userName"],
    sortable: true,
  },
  {
    name: "Quantity",
    selector: (row: RecentSalesTableType) => row["quantity"],
    sortable: true,
  },
  {
    name: "Price",
    selector: (row: RecentSalesTableType) => row["price"],
    sortable: true,
  },
];

export const topDealerCarouselData = [
  {
    user: [
      {
        name: "Thompson lee",
        src: "1.png",
        place: "Malasiya",
      },
      {
        name: "Johnson allon",
        src: "8.png",
        place: "Bangladesh",
      },
      {
        name: "williams reed",
        src: "3.png",
        place: "Belgium",
      },
      {
        name: "Jones king",
        src: "4.png",
        place: "Canada",
      },
      {
        name: "Brown davis",
        src: "5.png",
        place: "China",
      },
      {
        name: "Wilson Hill",
        src: "6.png",
        place: "Denmark",
      },
      {
        name: "Anderson ban",
        src: "7.png",
        place: "Japan",
      },
      {
        name: "Thompson lee",
        src: "8.png",
        place: "Malasiya",
      },
      {
        name: "Brown davis",
        src: "5.png",
        place: "China",
      },
      {
        name: "Wilson Hill",
        src: "6.png",
        place: "Denmark",
      },
      {
        name: "Anderson ban",
        src: "7.png",
        place: "Japan",
      },
      {
        name: "Thompson lee",
        src: "8.png",
        place: "Malasiya",
      },
    ],
  },
  {
    user: [
      {
        name: "Brown davis",
        src: "5.png",
        place: "China",
      },
      {
        name: "Wilson Hill",
        src: "6.png",
        place: "Denmark",
      },
      {
        name: "Anderson ban",
        src: "7.png",
        place: "Japan",
      },
      {
        name: "Thompson lee",
        src: "8.png",
        place: "Malasiya",
      },
      {
        name: "Thompson lee",
        src: "1.png",
        place: "Malasiya",
      },
      {
        name: "Johnson allon",
        src: "8.png",
        place: "Bangladesh",
      },
      {
        name: "williams reed",
        src: "3.png",
        place: "Belgium",
      },
      {
        name: "Thompson lee",
        src: "8.png",
        place: "Malasiya",
      },
      {
        name: "Jones king",
        src: "4.png",
        place: "Canada",
      },
      {
        name: "Wilson Hill",
        src: "6.png",
        place: "Denmark",
      },
      {
        name: "Anderson ban",
        src: "7.png",
        place: "Japan",
      },
      {
        name: "Jones king",
        src: "4.png",
        place: "Canada",
      },
    ],
  },
];
